import { gql, TypedDocumentNode } from '@apollo/client';
import type { Vendor } from '../models/Vendor';

export const ADD_VENDOR_MUTATION: TypedDocumentNode<{ added: boolean }, { input: Vendor }> = gql`
  mutation AddVendor($input: VendorModelInput!) {
    added: addVendor(input: $input)
  }
`;

export const UPDATE_VENDOR_MUTATION: TypedDocumentNode<{ updatedVendor: Vendor }, { id: number, input: Vendor }> = gql`
  mutation UpdateVendor($id: Int!, $input: VendorModelInput!) {
    updatedVendor: updateVendor(id: $id, input: $input) {
      id,
      name,
      address,
      city,
      zip,
      contactId
    }
  }
`;

export const DELETE_VENDOR_BY_ID_MUTATION: TypedDocumentNode<{ deleted: boolean }, { id: number }> = gql`
  mutation DeleteVendorById($id: Int!) {
    deleted: deleteVendorById(id: $id)
  }
`;

